/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/fileuploader-uppy';

export type Props = {
  handleClose: () => void;
  closeModalReturnRef: React.RefObject<HTMLButtonElement>;
};

const styles = {
  dialogHeading: css`
    margin-bottom: var(--cds-spacing-300);
  `,
  dialogText: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  dialogActions: css`
    margin-top: var(--cds-spacing-400);
  `,
};

const FileUploadErrorModal = ({ handleClose, closeModalReturnRef }: Props) => {
  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="dialog-heading"
      aria-describedby="dialog-content"
      {...(closeModalReturnRef?.current && {
        returnFocusRef: closeModalReturnRef,
      })}
    >
      <Dialog.HeadingGroup id="dialog-heading" css={styles.dialogHeading}>
        {_t('Your file upload failed.')}
      </Dialog.HeadingGroup>
      <Dialog.Content id="dialog-content">
        <Typography2 component="p" variant="bodyPrimary" css={styles.dialogText}>
          {_t('Please check your internet connection and reload the page.')}
        </Typography2>

        <Typography2 component="p" variant="bodyPrimary">
          <FormattedMessage
            message={_t(
              'You may be using a network that blocks your ability to upload files to Coursera. If that is the case, please try connecting to a different network and uploading again. If this continues to be an issue, you can contact {courseraLink} support for further assistance.'
            )}
            courseraLink={
              <a
                href="https://learner.coursera.help/hc/articles/208279886-Solve-problems-with-Coursera"
                target="_blank"
                rel="noopener noreferrer"
              >
                {_t('Coursera 24x7')}
              </a>
            }
          />
        </Typography2>
      </Dialog.Content>
      <Dialog.Actions css={styles.dialogActions}>
        <Button size="medium" variant="primary" onClick={handleClose}>
          {_t('Close')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default FileUploadErrorModal;
